/**
 * @generated SignedSource<<98e91abe7c14a1a34e77e19f63298a06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ExpertType = "BOTSTACKS_EXPERT" | "BUBBLE_EXPERT" | "BUILDSHIP_EXPERT" | "CONTRA_EXPERT_TEST" | "DESCRIPT_EXPERT" | "FLUTTERFLOW_EXPERT" | "FRAMER_EXPERT" | "GLORIFY_EXPERT" | "HEY_GEN_EXPERT" | "INSTANT_EXPERT" | "JITTER_EXPERT" | "KITTL_EXPERT" | "LOTTIEFILES_X_FIGMA_EXPERT" | "LOTTIEFILES_X_FRAMER_EXPERT" | "LOTTIEFILES_X_WEBFLOW_EXPERT" | "RELUME_EXPERT" | "REPLO_EXPERT" | "RIVE_EXPERT" | "SPLINE_EXPERT" | "WEBFLOW_EXPERT" | "WEBSTUDIO_EXPERT" | "WIX_STUDIO_EXPERT" | "%future added value";
export type TopIndependentStatus = "DISCOVERED" | "OPTED_IN" | "OPTED_OUT" | "UNDISCOVERED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useBadges_userProfile$data = {
  readonly firstName: string | null;
  readonly organizationV2: {
    readonly name: string;
    readonly workspace: {
      readonly activeSubscription?: {
        readonly createdAt: ContraAPIScalars.DateTime | null;
      } | null;
    } | null;
  } | null;
  readonly partnerExpertGroups: ReadonlyArray<ExpertType>;
  readonly platformEarningsBadge: string | null;
  readonly primaryProfessionalCategory: string | null;
  readonly showVerificationBadge: boolean;
  readonly showWalletActiveBadge: boolean;
  readonly topIndependentStatus: TopIndependentStatus;
  readonly workPreferences: {
    readonly minimumHourlyRate: number | null;
  };
  readonly " $fragmentType": "useBadges_userProfile";
};
export type useBadges_userProfile$key = {
  readonly " $data"?: useBadges_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"useBadges_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useBadges_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partnerExpertGroups",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showVerificationBadge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showWalletActiveBadge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topIndependentStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryProfessionalCategory",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platformEarningsBadge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkPreferences",
      "kind": "LinkedField",
      "name": "workPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minimumHourlyRate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organizationV2",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "workspace",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ClientWorkspaceSubscription",
                  "kind": "LinkedField",
                  "name": "activeSubscription",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "ClientWorkspace",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "f0e65e804dd2fefe951fcc3a321a0761";

export default node;
